export const translations = {
    "en": {
        "nav-home": "Home",
        "nav-gallery": "Gallery",
        "nav-contact": "Contact",
        "btn-quote": "Contact Us",
        "btn-gallery": "Gallery",
        "home-title": "Wood & Steel Works",
        "home-subtitle": "Premium handcrafted gazebos, tables, chairs, fences and more — built to last.",
        "home-feat-1": "Solid hardwood & structural steel",
        "home-feat-2": "Weather-resistant finishes",
        "home-feat-3": "Custom sizes & designs available",
        "home-feat-4": "Craftsmanship warranty",
        "contact-title": "Get in Touch",
        "contact-subtitle": "Ready to bring your wood & steel vision to life? We'd love to help.",
        "contact-name": "Name",
        "contact-name-ph": "Your Name",
        "contact-email": "Email",
        "contact-email-ph": "your@email.com",
        "contact-phone": "Phone",
        "contact-phone-ph": "+995 511 16 81 47",
        "contact-interest": "Interest",
        "contact-opt-default": "Select a product",
        "contact-opt-gazebo": "Gazebo / Pergola",
        "contact-opt-tables": "Tables",
        "contact-opt-chairs": "Chairs",
        "contact-opt-fences": "Fences",
        "contact-opt-lights": "Lighting",
        "contact-opt-custom": "Custom Project",
        "contact-opt-general": "General Question",
        "contact-msg": "Message",
        "contact-msg-ph": "Tell us about your project or question...",
        "contact-btn": "Send Message",
        "contact-call": "Call Us",
        "gallery-title-gazebos": "Gazebos / Pergolas",
        "gallery-desc-gazebos": "Premium gazebos combining high quality steel and fine woodworking.",
        "gallery-title-lights": "Light Poles",
        "gallery-desc-lights": "Steel light poles for illuminating driveways, gardens, and pathways.",
        "gallery-title-tables": "Tables",
        "gallery-desc-tables": "Solid wood and industrial steel outdoor dining and coffee tables.",
        "gallery-title-chairs": "Chairs",
        "gallery-desc-chairs": "Comfortable, wide-armed outdoor lounging chairs in premium treated wood.",
        "gallery-title-fences": "Fences",
        "gallery-desc-fences": "Modern privacy fencing with laser-cut steel panels and robust posts.",
        "gallery-header-title": "Project Gallery",
        "seo-home-title": "Ironwood | Custom Gazebos & Modern Pergolas in Georgia",
        "seo-home-desc": "Order premium custom gazebos and modern pergolas in Georgia. Handcrafted wood and steel outdoor furniture, including tables, chairs, and fences. Get a free quote today.",
        "seo-gallery-title": "Gallery | Ironwood",
        "seo-gallery-desc": "Browse Ironwood's portfolio of premium handcrafted gazebos, pergolas, outdoor tables, chairs, benches, steel fences, and decorative lighting poles built in Georgia.",
        "seo-contact-title": "Contact Us | Ironwood",
        "seo-contact-desc": "Get in touch with Ironwood for custom wood and steel outdoor furniture in Georgia. Call, WhatsApp, or send a message — free consultation and quote available.",
        "seo-404-title": "Page Not Found | Ironwood",
        "seo-404-desc": "The page you are looking for does not exist.",
        "alt-gazebo-1": "Custom wooden gazebo with steel frame in a garden setting",
        "alt-gazebo-2": "Handcrafted pergola with decorative woodwork and steel supports",
        "alt-gazebo-3": "Premium gazebo with seating area surrounded by greenery",
        "alt-gazebo-4": "Large wooden gazebo with metal roof in a backyard",
        "alt-gazebo-5": "Elegant gazebo structure with treated wood and steel joints",
        "alt-gazebo-6": "Compact garden gazebo with modern design",
        "alt-pergola-1": "Open-frame wooden pergola attached to outdoor patio",
        "alt-light-pole-1": "Decorative steel light pole illuminating a garden pathway",
        "alt-pole-2": "Tall outdoor lighting pole with warm light fixture",
        "alt-pole-3": "Steel driveway light pole with modern design",
        "alt-table-1": "Solid wood outdoor dining table with industrial steel legs",
        "alt-table-2": "Handcrafted wooden coffee table with metal frame",
        "alt-table-3": "Premium outdoor table with treated wood surface",
        "alt-chair-1": "Wide-armed outdoor lounging chair in treated hardwood",
        "alt-chair-2": "Comfortable garden chair with steel and wood construction",
        "alt-chair-3": "Premium outdoor seating chair with armrests",
        "alt-bench-1": "Sturdy outdoor wooden bench with steel supports",
        "alt-bench-2": "Garden bench with treated wood slats and metal frame",
        "alt-bench-3": "Long outdoor bench for patio seating",
        "alt-fence-1": "Modern privacy fence with laser-cut steel panels",
        "alt-fence-2": "Wood and metal boundary fence with decorative pattern",
        "alt-fence-3": "Contemporary steel fence panels with robust posts",
        "alt-fence-4": "Residential privacy fence combining wood and metalwork"
    },
    "ge": {
        "nav-home": "მთავარი",
        "nav-gallery": "გალერეა",
        "nav-contact": "კონტაქტი",
        "btn-quote": "დაგვიკავშირდით",
        "btn-gallery": "გალერეა",
        "home-title": "ხის და ლითონის ნაკეთობები",
        "home-subtitle": "პრემიუმ ხარისხის ხის და ლითონის ნაკეთობები — ფანჩატურები, მაგიდები, სკამები, ლამპიონები, ღობეები და სხვა",
        "home-feat-1": "მაღალი ხარისხის ხე და ლითონი",
        "home-feat-2": "ამინდის პირობებისადმი მედეგი",
        "home-feat-3": "ხელმისაწვდომია ინდივიდუალური ზომები და დიზაინი",
        "home-feat-4": "ხარისხის გარანტია",
        "contact-title": "დაგვიკავშირდით",
        "contact-subtitle": "თუ გსურთ თქვენი იდეის რეალობად ქცევა, სიამოვნებით დაგეხმარებით.",
        "contact-name": "სახელი",
        "contact-name-ph": "თქვენი სახელი",
        "contact-email": "ელფოსტა",
        "contact-email-ph": "თქვენი@email.com",
        "contact-phone": "ტელეფონი",
        "contact-phone-ph": "+995 511 16 81 47",
        "contact-interest": "სასურველი პროდუქტი",
        "contact-opt-default": "აირჩიეთ სასურველი პროდუქტი",
        "contact-opt-gazebo": "ფანჩატური / პერგოლა",
        "contact-opt-tables": "მაგიდები",
        "contact-opt-chairs": "სკამები",
        "contact-opt-fences": "ღობეები",
        "contact-opt-lights": "ეზოს განათება",
        "contact-opt-custom": "ინდივიდუალური პროექტი",
        "contact-opt-general": "ზოგადი კითხვა",
        "contact-msg": "მესიჯი",
        "contact-msg-ph": "მოგვწერეთ თქვენი შეკითხვის ან პროექტის შესახებ...",
        "contact-btn": "შეტყობინების გაგზავნა",
        "contact-call": "დაგვირეკეთ",
        "gallery-title-gazebos": "ფანჩატურები / პერგოლები",
        "gallery-desc-gazebos": "ფანჩატურები და პერგოლები დამზადებულია მაღალი ხარისხის ფოლადით და დამუშავებული ხით.",
        "gallery-title-lights": "განათების ბოძები",
        "gallery-desc-lights": "ფოლადის განათების ბოძები ეზოების, ბაღებისა და ბილიკების გასანათებლად.",
        "gallery-title-tables": "ეზოს მაგიდები",
        "gallery-desc-tables": "მყარი ხის და ინდუსტრიული ფოლადისგან დამზადებული გარე სასადილო და ყავის მაგიდები.",
        "gallery-title-chairs": "ეზოს სკამები",
        "gallery-desc-chairs": "კომფორტული, განიერი გარე სკამები, დამზადებული პრემიუმ ხარისხის დამუშავებული ხის და ფოლადისგან.",
        "gallery-title-fences": "ღობეები",
        "gallery-desc-fences": "თანამედროვე ღობეები პლაზმით დამუშავებული ფოლადის პანელებითა და მტკიცე ბოძებით.",
        "gallery-header-title": "პროექტების გალერეა",
        "seo-home-title": "Ironwood | ფანჩატურები შეკვეთით და თანამედროვე პერგოლები",
        "seo-home-desc": "დაამზადეთ პრემიუმ ხარისხის ფანჩატურები შეკვეთით და თანამედროვე პერგოლები საქართველოში. ინდივიდუალური დიზაინი, ხის და ლითონის ნაკეთობები, უფასო კონსულტაცია.",
        "seo-gallery-title": "გალერეა | Ironwood",
        "seo-gallery-desc": "დაათვალიერეთ Ironwood-ის პრემიუმ ფანჩატურების, პერგოლების, ეზოს მაგიდების, სკამების, ფოლადის ღობეებისა და განათების ბოძების პროექტების გალერეა.",
        "seo-contact-title": "კონტაქტი | Ironwood",
        "seo-contact-desc": "დაგვიკავშირდით Ironwood-ში ხის და ლითონის ნაკეთობების შესაკვეთად. დარეკეთ, მოგვწერეთ WhatsApp-ით — უფასო კონსულტაცია და შეთავაზება.",
        "seo-404-title": "გვერდი ვერ მოიძებნა | Ironwood",
        "seo-404-desc": "თქვენ მიერ მოთხოვნილი გვერდი არ არსებობს.",
        "alt-gazebo-1": "ხის ფანჩატური ლითონის კარკასით ბაღში",
        "alt-gazebo-2": "ხელნაკეთი პერგოლა დეკორატიული ხის სამუშაოთი",
        "alt-gazebo-3": "პრემიუმ ფანჩატური დასაჯდომი ადგილით მწვანე გარემოში",
        "alt-gazebo-4": "დიდი ხის ფანჩატური ლითონის სახურავით ეზოში",
        "alt-gazebo-5": "ელეგანტური ფანჩატური დამუშავებული ხით და ფოლადის შეერთებებით",
        "alt-gazebo-6": "კომპაქტური ბაღის ფანჩატური თანამედროვე დიზაინით",
        "alt-pergola-1": "ღია ჩარჩოიანი ხის პერგოლა ტერასაზე",
        "alt-light-pole-1": "დეკორატიული ფოლადის სანათი ბოძი ბაღის ბილიკის გასანათებლად",
        "alt-pole-2": "მაღალი გარე განათების ბოძი თბილი შუქით",
        "alt-pole-3": "ფოლადის ბოძი ეზოს განათებისთვის თანამედროვე დიზაინით",
        "alt-table-1": "მყარი ხის ეზოს სასადილო მაგიდა ლითონის ფეხებით",
        "alt-table-2": "ხელნაკეთი ხის ყავის მაგიდა ლითონის ჩარჩოთი",
        "alt-table-3": "პრემიუმ გარე მაგიდა დამუშავებული ხის ზედაპირით",
        "alt-chair-1": "განიერი გარე სკამი დამუშავებული ხისგან",
        "alt-chair-2": "კომფორტული ბაღის სკამი ფოლადისა და ხის კონსტრუქციით",
        "alt-chair-3": "პრემიუმ გარე სკამი სახელურებით",
        "alt-bench-1": "მტკიცე გარე ხის სკამი ფოლადის საყრდენებით",
        "alt-bench-2": "ბაღის სკამი დამუშავებული ხის ფიცრებით და ლითონის ჩარჩოთი",
        "alt-bench-3": "გრძელი გარე სკამი ტერასის დასაჯდომად",
        "alt-fence-1": "თანამედროვე ღობე ლაზერით ამოჭრილი ფოლადის პანელებით",
        "alt-fence-2": "ხისა და ლითონის ღობე დეკორატიული ნიმუშით",
        "alt-fence-3": "თანამედროვე ფოლადის ღობის პანელები მტკიცე ბოძებით",
        "alt-fence-4": "საცხოვრებელი კონფიდენციალურობის ღობე ხისა და ლითონის კომბინაციით"
    }
};
